import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
// import { objArrayToMap } from 'app/admin/common/util/CommonUtil';
import ModelValidationEditDto from '../dto/ModelValidationEditDto';

class ModelValidationEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'modelValidationEditControl';
	}

	/**
	 * @return {Promise<ModelValidationEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new ModelValidationEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<ModelValidationEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new ModelValidationEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {ModelValidationEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto: { ...dto/*, tolerance: objArrayToMap(dto.tolerance, 'name', 'tolerance')*/}
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {ModelValidationEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto: { ...dto/*, tolerance: objArrayToMap(dto.tolerance, 'name', 'tolerance')*/ }
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new ModelValidationEditService();
